import * as React from "react";
import "./styles.scss";
var Loading = function (_a) {
    var active = _a.active, msg = _a.msg, absolute = _a.absolute;
    return (React.createElement("div", { className: "loading-container ".concat(active ? 'active' : '', " ").concat(absolute ? "absolute" : "") },
        React.createElement("div", { className: "loading-box" },
            msg && React.createElement("h4", { className: "msg" }, msg),
            React.createElement("div", { className: "loader" }))));
};
export default Loading;
//# sourceMappingURL=index.js.map